import React, { useEffect } from 'react';
import '../styles/modal.css';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppModal = ({
  isOpen,
  onClose,
  onContinue,
  whatsappNumber,
  setWhatsappNumber,
  rememberMe,
  setRememberMe
}) => {

  // Load saved phone number from localStorage on mount
  useEffect(() => {
    if (isOpen) {
      const savedNumber = localStorage.getItem('whatsappNumber');
      const savedRemember = localStorage.getItem('whatsappRememberMe');
      if (savedNumber && savedRemember === 'true') {
        setWhatsappNumber(savedNumber);
        setRememberMe(true);
      }
    }
    // eslint-disable-next-line
  }, [isOpen]);

  if (!isOpen) return null;

  const handleContinue = () => {
    if (whatsappNumber) {
      if (rememberMe) {
        localStorage.setItem('whatsappNumber', whatsappNumber);
        localStorage.setItem('whatsappRememberMe', 'true');
      } else {
        localStorage.removeItem('whatsappNumber');
        localStorage.setItem('whatsappRememberMe', 'false');
      }
      onContinue();
    }
  };

  const handlePhoneChange = (e) => {
    // Basic phone number formatting
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 0) {
      if (value.length <= 3) {
        value = `+${value}`;
      } else if (value.length <= 6) {
        value = `+${value.slice(0, 3)} ${value.slice(3)}`;
      } else if (value.length <= 10) {
        value = `+${value.slice(0, 3)} ${value.slice(3, 6)} ${value.slice(6)}`;
      } else {
        value = `+${value.slice(0, 3)} ${value.slice(3, 6)} ${value.slice(6, 10)} ${value.slice(10, 14)}`;
      }
    }
    setWhatsappNumber(value);
    // If rememberMe is checked, update localStorage live
    if (rememberMe) {
      localStorage.setItem('whatsappNumber', value);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {/* <h2 className="modal-title">Enter your WhatsApp number</h2> */}

        <div className="whatsapp-icon">
          <FaWhatsapp size={56} color="#25D366" />
        </div>

        <input
          type="tel"
          className="modal-input"
          placeholder="+1 (555) 000-0000"
          value={whatsappNumber}
          onChange={handlePhoneChange}
          autoFocus
        />

        <label className="remember-me">
          <input
            type="checkbox"
            checked={rememberMe}
            onChange={(e) => {
              setRememberMe(e.target.checked);
              localStorage.setItem('whatsappRememberMe', e.target.checked ? 'true' : 'false');
              if (!e.target.checked) {
                localStorage.removeItem('whatsappNumber');
              } else {
                localStorage.setItem('whatsappNumber', whatsappNumber);
              }
            }}
          />
          <span>Remember me</span>
        </label>

        <button
          className="continue-button"
          onClick={handleContinue}
          disabled={!whatsappNumber}
        >
          Continue
        </button>

        <button className="maybe-later" onClick={onClose}>
          Maybe Later
        </button>

        <p className="spam-note">No spam. Unsubscribe anytime</p>
      </div>
    </div>
  );
};

export default WhatsAppModal;